import * as React from 'react'

function SvgEditIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="M4 10h11v2H4v-2Zm0-2h11V6H4v2Zm0 8h7v-2H4v2Zm15.01-3.13.71-.71a.996.996 0 0 1 1.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71-2.12-2.12Zm-.71.71-5.3 5.3V21h2.12l5.3-5.3-2.12-2.12Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgEditIcon
